export const getAccess = () => useCookie("access").value;
